import { HStack, Icon, Text } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';
import { Pressable, StyleProp, ViewStyle } from 'react-native';

import { SinacorAccount } from '../../../store/customer/types';

const triggerStyle = {
  alignSelf: 'stretch' as const,
  paddingVertical: Utils.Token.ToInt(Spacing, 'inset.quarck'),
};

interface SelectionTriggerProps {
  account: SinacorAccount;
  triggerProps?: Record<string, unknown>;
  onPress?: () => void;
  chevronName?: 'ChevronDown' | 'ChevronUp';
}

export const SelectionTrigger: React.FC<SelectionTriggerProps> = ({
  account,
  triggerProps,
  onPress,
  chevronName = 'ChevronDown',
}) => {
  const { style: forwardedTriggerStyle, ...restTriggerProps } = (triggerProps || {}) as {
    style?: StyleProp<ViewStyle>;
  };

  const pressableProps = restTriggerProps as {
    onPress?: () => void;
  };

  return (
    <Pressable
      testID="account-select"
      {...restTriggerProps}
      onPress={onPress || pressableProps.onPress}
      style={[triggerStyle, forwardedTriggerStyle]}>
      <HStack alignItems="center" justifyContent="space-between" pr="inline.nano">
        <Text color="neutral.black" flex={1} numberOfLines={1} ellipsizeMode="tail">
          {account.custodyAccountNormalized}
        </Text>
        <Icon name={chevronName} size="xxxs" color="neutral.medium" />
      </HStack>
    </Pressable>
  );
};
